import React from 'react';
import { Link } from 'react-router-dom';
import PlatformLayout from '../PlatformLayout';
import { ICONS, Arrow, IconKey } from '../icons';

type Row = { icon: IconKey; kicker: string; title: string; body: string; points: string[]; flip?: boolean };

const ROWS: Row[] = [
  { icon: 'site', kicker: 'Full site', title: 'Let SGOKit be your whole website',
    body: 'Turn on the full site and SGOKit becomes your public presence — a homepage, a donation page, an application portal, and a dedicated resource page for every state you operate in. One toggle, a real website.',
    points: ['Homepage, donate, and apply out of the box', 'A resource page per state you operate in', 'Your footprint map, front and center', 'Full-site on/off whenever you want'] },
  { icon: 'theming', kicker: 'Theme builder', title: 'Your colors, your character', flip: true,
    body: 'Pick a palette and SGOKit dresses every page in it. Prefer to hand-build it? Bring your own HTML — our menus and pages are designed to drop into a UI you already control.',
    points: ['Color palette of your choice', 'Typography and logo', 'BYOHTML for full control', 'Consistent across site and embeds'] },
  { icon: 'embed', kicker: 'Embeds', title: 'Or just the parts you need',
    body: 'Already have a site you love? Take only the donation and application menus and embed them where you want. The machinery runs on SGOKit; the look stays yours.',
    points: ['Embeddable donation menu', 'Embeddable application intake', 'Drop into any existing site', 'Fully customizable presentation'] },
];

export default function SiteBuilder() {
  return (
    <PlatformLayout>
      <section className="sgk-section sgk-section--tight">
        <div className="sgk-wrap">
          <div className="sgk-head sgk-reveal">
            <span className="sgk-eyebrow">Your site</span>
            <h2>Be a whole website — or <em>just a menu.</em></h2>
            <p>SGOKit can carry your entire web presence, or hand you embeddable pieces
              for a site you already run. Either way, the donations and applications flow
              through the same platform.</p>
          </div>
        </div>
      </section>

      <section className="sgk-section" style={{ paddingTop: 0 }}>
        <div className="sgk-wrap">
          {ROWS.map((r) => {
            const Icon = ICONS[r.icon];
            return (
              <div className={`sgk-feature sgk-reveal${r.flip ? ' sgk-feature--flip' : ''}`} key={r.title}>
                <div>
                  <span className="sgk-eyebrow">{r.kicker}</span>
                  <h3>{r.title}</h3>
                  <p style={{ marginTop: 14 }}>{r.body}</p>
                  <ul>{r.points.map((p) => <li key={p}>{p}</li>)}</ul>
                </div>
                <div className="sgk-feature__media">
                  <div className="sgk-module__icon" style={{ width: 96, height: 96, borderRadius: 20 }}>
                    <Icon size={52} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="sgk-cta">
        <div className="sgk-wrap sgk-cta__grid">
          <div>
            <h2>Ship a site, not a project.</h2>
            <p>Start with donations today; switch on the full site when you&apos;re ready.</p>
          </div>
          <Link to="/signup" className="sgk-btn sgk-btn--navy" data-testid="site-cta-start-button">
            Start an SGO <Arrow />
          </Link>
        </div>
      </section>
    </PlatformLayout>
  );
}
